import { useMatches } from '@remix-run/react';

/**
 * A hook that returns the destination route of the back button
 * This can be used to implement back buttons
 */
export function useBackButtonDestination() {
  const matches = useMatches();

  for (let i = matches.length - 1; i >= 0; i--) {
    const match = matches[i];
    if (match.handle?.getParentPage) {
      return { backButtonDestination: match.handle?.getParentPage(match) };
    }
  }

  return { backButtonDestination: undefined };
}
